import { SenseiApi } from '../utils/api';
import { DispatchType } from '../types/rx-actions';
import {
  OrganizationIdOrAll,
  ALL_ORGANIZATIONS,
} from '../types/all-organizations';
import { Toaster } from '@densityco/ui';

import {
  MultiPointInstallationCreationAction,
  MultiPointInstallationCreationActionTypes,
} from '../types/multi-point-installation-creation';

import { MultiPointInstallationListActionTypes } from '../types/multi-point-installation-list';

import { Sort } from '../types/sort';
import { Filter, FilterOfValueType } from '../types/filters';

import { Organization } from '../types/api';

import { generateParams } from '../rx-stores/multi-point-installation-list';

export async function createMpis(
  dispatch: DispatchType,
  history: any,
  accessToken: string,
  organizationIdOrAll: OrganizationIdOrAll,
  body: any,
) {
  dispatch({
    type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_LOADING,
  });

  if (organizationIdOrAll === ALL_ORGANIZATIONS) {
    Toaster.showToast({
      type: 'error',
      text: `Cannot create MPI when 'all organizations' is selected`,
      timeout: 10000,
    });
    return;
  }

  let response;
  try {
    response = await SenseiApi.multiPointInstallationCreate(
      accessToken,
      organizationIdOrAll,
      body,
    );
  } catch (error) {
    dispatch({
      type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_ERROR,
      error,
    });
    Toaster.showToast({ text: error.message, type: 'error', timeout: 10000 });
    return;
  }

  dispatch({
    type: MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_COMPLETE,
    id: response.id,
  });
  Toaster.showToast({ text: 'Created MPI.' });

  // Replace the current history item, so that pressing back won't go to the creation form.
  history.replace(`/${organizationIdOrAll}/multi-point-installations`);
}

// Fetch a list of all MPIs and put them into the `MultiPointInstallationStore`
export async function fetchNextPageOfMPIs(
  dispatch: DispatchType,
  jwtToken: string,
  filters: Filter[],
  sort: Sort,
  searchText: string,
  page: number,
  organizationId: Organization['id'] | null,
) {
  dispatch({
    type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_LOADING,
  });

  // Apply filters to the results that are returned.
  const params = {
    ...generateParams(filters, searchText, sort, organizationId),
    page: page,
  };

  let mpis: any;
  try {
    mpis = await SenseiApi.multiPointInstallationList(jwtToken, params);
  } catch (error) {
    dispatch({
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_COMPLETE,
    mpis: mpis.results,
  });
}
